(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cl-comparetor"] && !Shopify.designMode) return;
  try {
    
  let scrollPosition = 0;
  function disableScroll() {
    scrollPosition = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  }
  function enableScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollPosition);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Initialize main swiper
    const swiper = new Swiper('.cl-comparetor-card-swiper', {
      slidesPerView: 3,
      spaceBetween: 15,
      centeredSlides: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: { slidesPerView: 3, spaceBetween: 10 },
        480: { slidesPerView: 3, spaceBetween: 15 },
        640: { slidesPerView: 5, spaceBetween: 15 },
        768: { slidesPerView: 5, spaceBetween: 20 },
        1024: { slidesPerView: 5, spaceBetween: 20 },
        1200: { slidesPerView: 5, spaceBetween: 20 },
      },
    });

    // Initialize popup swipers with heading change
    const slideHeadings =
      window.Shopify && Shopify.locale === 'ar' ? ['صندوق الأصابع', 'قوس القدم', 'الكعب'] : ['TOE BOX', 'ARCH', 'HEEL'];

    const popupSwipers = {};

    document.querySelectorAll('.popup-swiper').forEach((swiperEl) => {
      const popup = swiperEl.closest('.cl-comparator--popup');
      const popupId = popup?.id;
      const headingEl = popup.querySelector('.cl-comparator--popup-heading');

      const popupSwiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
        on: {
          slideChange: function () {
            const currentIndex = this.activeIndex;
            if (headingEl) {
              headingEl.textContent = slideHeadings[currentIndex] || 'Comparison';
            }
          },
        },
      });

      // Set initial heading
      if (headingEl) {
        headingEl.textContent = slideHeadings[0];
      }

      if (popupId) popupSwipers[popupId] = popupSwiper;
    });

    const cards = document.querySelectorAll('.cl-comparator--card');
    const popups = document.querySelectorAll('.cl-comparator--popup');
    const overlay = document.querySelector('.cl-comparator--popup-overlay');

    // Toggle overlay
    function togglePopupOverlay(show) {
      if (overlay) overlay.style.display = show ? 'block' : 'none';
    }

    // Close popup
    function closePopup(popup) {
      if (popup) {
        popup.classList.remove('active');
        popup.style.display = 'none';
        enableScroll();

        togglePopupOverlay(false);
      }
    }

    // Event handlers for cards
    cards.forEach((card) => {
      const compareBtn = card.querySelector('.cl-comparator--compare-btn');

      card.addEventListener('click', () => {
        cards.forEach((c) => c.classList.remove('active'));
        popups.forEach((p) => p.classList.remove('active'));
        card.classList.add('active');
      });

      if (compareBtn) {
        compareBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          const shoe = card.getAttribute('data-shoe');
          const popup = document.getElementById('cl-comparator--popup-' + shoe);

          if (popup) {
            // Close all popups first
            popups.forEach((p) => {
              p.classList.remove('active');
              p.style.display = 'none';
            });

            // Show the target popup
            popup.classList.add('active');
            popup.style.display = 'block';
            disableScroll();

            togglePopupOverlay(true);

            // Update Swiper in the popup
            setTimeout(() => {
              const popupSwiper = popupSwipers[popup.id];
              if (popupSwiper) {
                popupSwiper.update();
                popupSwiper.slideTo(0);
              }
            }, 100);
          }
        });
      }
    });

    // Close popup on close button
    document.querySelectorAll('.cl-comparator--popup-close').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const popup = btn.closest('.cl-comparator--popup');
        closePopup(popup);
      });
    });

    // Close on click outside (overlay)
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('cl-comparator--popup')) {
        closePopup(e.target);
      }
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        popups.forEach((popup) => closePopup(popup));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
